import {
  Button,
  FormControl,
  InputLabel,
  makeStyles,
  MenuItem,
  Select,
} from '@material-ui/core';
import MUIDataTable from 'mui-datatables';
import { useEffect, useState } from 'react';
import { useCourses } from '../courses/Courses';
import { useGrades } from '../grades/Grades';
import { useInstitutions } from '../institutions/Institutions';
import { useSeries } from '../series/Series';

const useStyles = makeStyles((theme) => ({
  input: {
    marginTop: '20px',
    width: '15%',
  },
}));

function useForm() {
  const [entries, setEntries] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setEntries({ ...entries, [name]: value });
  };

  return {
    handleChange,
    entries,
  };
}

export function QuestionnaireCalifications(props) {
  const { institutions } = useInstitutions();
  const { series } = useSeries();
  const { grades } = useGrades();
  const { courses, setCourses } = useCourses();
  const { handleChange, entries } = useForm();
  const [table, setTable] = useState({
    columns: [],
    data: [],
  });
  const classes = useStyles();

  useEffect(() => {
    fetch(`https://api.edicionesmilenio.com/api/courses/filter`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        grade: entries?.grade,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        setCourses(data.data);
      });
  }, [entries?.grade, setCourses]);

  const search = () => {
    fetch(
      `https://api.edicionesmilenio.com/api/questionnairecalifications/filter`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          institution: entries?.institution,
          serie: entries?.serie,
          grade: entries?.grade,
          course: entries?.course,
        }),
      }
    )
      .then((res) => res.json())
      .then((json) => {
        let data = [];
        let columns = [
          {
            name: 'name',
            label: 'Nombre de estudiante',
          },
        ];

        console.log(json.data);

        json?.data?.forEach((calification) => {
          columns.push({
            name: calification?.questionnaire?.title,
            label: calification?.questionnaire?.title,
          });
        });

        columns.push({
          name: 'average',
          label: 'Nota Promedio',
        });

        json?.data?.forEach((calification) => {
          let index = data.findIndex(
            (e) => e.name === calification?.student?.name
          );
          if (index === -1) {
            data.push({
              name: calification?.student?.name,
              [calification?.questionnaire?.title]:
                calification?.calification?.toFixed(1),
            });
          } else {
            data[index][calification?.questionnaire?.title] =
              calification?.calification?.toFixed(1);
          }
        });

        data.forEach((student) => {
          let sum = 0;
          let count = 0;
          for (let key in student) {
            if (key !== 'name') {
              sum += Number(student[key]);
              count++;
            }
          }
          student.average = sum / count;
        });
        setTable({
          columns,
          data,
        });
      });
  };

  return (
    <div style={{ width: '100%', padding: '20px' }}>
      <p
        style={{
          width: '100%',
          color: '#888',
          marginBottom: '50px',
          alignSelf: 'center',
          justifySelf: 'center',
          textAlign: 'center',
        }}
      >
        Estimado administrador, desde esta sección podrás visualizar los
        resultados obtenidos por los estudiantes de los cuestionarios creados
        por los docentes, utiliza los filtros para obtener la lista de
        resultados, recuerda usar las herramientas de gestión, filtros, buscar,
        descargar, entre otros.
      </p>
      <div
        style={{
          display: 'flex',
          width: '100%',
          justifyContent: 'space-evenly',
          alignItems: 'center',
        }}
      >
        <FormControl variant="outlined" className={classes.input}>
          <InputLabel id="institution-label">Institución</InputLabel>
          <Select
            labelId="institution-label"
            id="institution"
            name="institution"
            value={entries?.institution}
            onChange={handleChange}
          >
            {institutions.map((institution) => (
              <MenuItem value={institution?._id}>{institution?.name}</MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl variant="outlined" className={classes.input}>
          <InputLabel id="series-label">Serie</InputLabel>
          <Select
            labelId="series-label"
            id="series"
            name="serie"
            value={entries?.serie}
            onChange={handleChange}
          >
            {series.map((serie) => (
              <MenuItem value={serie?._id}>{serie?.name}</MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl variant="outlined" className={classes.input}>
          <InputLabel id="grade-label">Grado</InputLabel>
          <Select
            labelId="grade-label"
            id="grade"
            name="grade"
            value={entries?.grade}
            onChange={handleChange}
          >
            {grades.map((grade) => (
              <MenuItem value={grade?._id}>{grade?.name}</MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl variant="outlined" className={classes.input}>
          <InputLabel id="course-label">Curso</InputLabel>
          <Select
            labelId="course-label"
            id="course"
            name="course"
            value={entries?.course}
            onChange={handleChange}
          >
            {courses.map((course) => (
              <MenuItem value={course?._id}>{course?.numericName}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <Button
          variant="contained"
          color="primary"
          style={{ height: '30px' }}
          onClick={search}
        >
          Buscar
        </Button>
      </div>
      <div style={{ width: '100%', marginTop: '20px' }}>
        <MUIDataTable
          title={'Calificaciones'}
          data={table?.data}
          columns={table?.columns}
          options={{
            filterType: 'checkbox',
            download: true,
            viewColumns: true,
            filter: false,
          }}
        />
      </div>
    </div>
  );
}
